export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              关于我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              了解西瓜影视的背后故事与使命愿景
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-background-50 rounded-2xl p-6 md:p-10">
              <div className="flex flex-col lg:flex-row gap-8 md:gap-10 items-center">
                <div className="flex-shrink-0">
                  <div className="w-24 h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
                    <i className="ri-movie-2-line text-background-50 text-4xl"></i>
                  </div>
                </div>
                <div className="flex-1 text-center lg:text-left">
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                    西瓜影视 — 让每个人都能享受高清流畅的观影体验
                  </h3>
                  <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-3">
                    <p>
                      西瓜影视成立于2024年，是一家专注于高清影视在线观看的互联网平台。我们致力于为全球华语观众提供海量高清电影、电视剧、综艺、动漫及纪录片资源，让每一位用户都能以最简单的方式获取最优质的影视内容。
                    </p>
                    <p>
                      平台依托先进的智能CDN全球加速网络和自适应码率技术，无论您身在何处、使用何种设备，都能享受<strong>流畅不缓冲</strong>的播放体验。从手机到平板到大屏电视，西瓜影视始终如一地提供<strong>蓝光超清画质</strong>的极致观影享受。
                    </p>
                    <p>
                      我们拥有一支热爱影视的专业内容团队，每日精选优质片源，7×24小时持续更新，确保热门影视第一时间上线。同时，我们坚持用户至上的原则，不断优化产品体验，让西瓜影视成为您观影追剧的首选平台。
                    </p>
                  </div>

                  <div className="grid grid-cols-3 gap-4 mt-8">
                    <div className="text-center p-4 rounded-xl bg-primary-50">
                      <p className="text-2xl font-bold text-primary-500 font-heading">10万+</p>
                      <p className="text-xs text-foreground-500 mt-1">影视资源</p>
                    </div>
                    <div className="text-center p-4 rounded-xl bg-accent-50">
                      <p className="text-2xl font-bold text-accent-600 font-heading">5000万+</p>
                      <p className="text-xs text-foreground-500 mt-1">累计用户</p>
                    </div>
                    <div className="text-center p-4 rounded-xl bg-secondary-50">
                      <p className="text-2xl font-bold text-secondary-600 font-heading">99.9%</p>
                      <p className="text-xs text-foreground-500 mt-1">播放成功率</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}